import { apiClient } from '@/api/client'
import { ORGANIZATIONS } from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'

export type CustomDomainStatus = 'pending' | 'active' | 'failed'

export interface CustomDomain {
  hostname: string
  status: CustomDomainStatus
  /** The two records to add at the DNS provider. */
  records: Array<{ type: 'CNAME' | 'TXT'; name: string; value: string }>
  verifiedAt: string | null
  lastCheckedAt: string | null
  lastCheck: { ownership: boolean; routing: boolean; error?: string } | null
}

export interface CustomDomainState {
  domain: CustomDomain | null
  /** Where domains point; null while the platform hasn't enabled custom domains. */
  target: string | null
}

/** Shared by the settings pane and the section switch, so they read one cached answer. */
export const CUSTOM_DOMAIN_QUERY_KEY = ['custom-domain'] as const

export async function getCustomDomain(): Promise<CustomDomainState> {
  const { data } = await apiClient.get<ApiResponseWrapper<CustomDomainState>>(
    ORGANIZATIONS.CUSTOM_DOMAIN
  )
  return data.data
}

export async function addCustomDomain(hostname: string): Promise<CustomDomain> {
  const { data } = await apiClient.post<ApiResponseWrapper<CustomDomain>>(
    ORGANIZATIONS.CUSTOM_DOMAIN,
    { hostname }
  )
  return data.data
}

export async function verifyCustomDomain(): Promise<CustomDomain> {
  const { data } = await apiClient.post<ApiResponseWrapper<CustomDomain>>(
    ORGANIZATIONS.CUSTOM_DOMAIN_VERIFY
  )
  return data.data
}

export async function removeCustomDomain(): Promise<void> {
  await apiClient.delete(ORGANIZATIONS.CUSTOM_DOMAIN)
}
